import { useQuery } from '@apollo/client';
import { MY_ACTIVITIES } from '@src/graphql/queries/activity';
import { useActivityFilter } from '@src/hooks/useActivityFilter';
import { pick } from 'lodash';
import { useMemo } from 'react';
export const useMyActivities = ({ limit, key }) => {
    const { filter, setFilter, hasFilter, statuses } = useActivityFilter({ key });
    const { data, error, loading, refetch } = useQuery(MY_ACTIVITIES, {
        variables: {
            spec: {
                pagination: {
                    page: 1,
                    pageSize: limit || 200,
                },
                ...pick(filter, 'dateRange', 'type'),
                statuses,
            },
        },
    });
    const myActivities = useMemo(() => {
        return (data?.myActivities || []);
    }, [data?.myActivities]);
    return { myActivities, refetch, error, loading, filter, setFilter, hasFilter };
};
